export default Object.freeze({
  ASISTENCIA_MIPE: 'Asistencia MiPE',
  SUPERVISOR: 'Supervisor',
  APPLICANT: 'Solicitante',
  ADMIN: 'Administrador',
  INVESTIGATOR: 'Investigador',
});
